module.exports = __webpack_public_path__ + "img/teacher.d5f13271.png";